<template>
  <div id="DocumentLimitTransactionDebtorInformation" class="sun not-full">
    <div class="title">
      대출자 정보
    </div>
    <table>
      <tr>
        <td>성명</td>
        <td>{{user.name}}</td>
      </tr>
      <tr>
        <td>생년월일</td>
        <td>{{user.birthdate}}</td>
      </tr>
      <tr>
        <td>휴대폰 번호</td>
        <td>{{user.phone}}</td>
      </tr>
      <tr>
        <td>상점명</td>
        <td>{{user.store.name}}</td>
      </tr>
      <tr>
        <td>사업자등록번호</td>
        <td>{{user.store.business_license_number}}</td>
      </tr>
      <tr>
        <td>주소</td>
        <td>{{user.store.address1}}</td>
      </tr>
    </table>
    <div class="agree" ref="step1">
      대출자 정보에 대한 내용에
      <button @click="agree()"
              :style="{'color': (isComplete?'#1baaf1':'#727d8c')}">
        확인함
      </button>
    </div>
  </div>
</template>

<script>
// Service Section
import AuthService from '@/service/auth/AuthService'

// Variable Section
let self

export default {
  name: 'DocumentLimitTransactionDebtorInformation',
  props: {
    isAgreed: {
      type: Boolean,
      default() { return false }
    }
  },
  data: function () {
    return {
      user: null,
      isComplete: false
    }
  },
  computed: {},
  created() {
    self = this
    self.user = AuthService.getProfile()
    if (self.isAgreed) {
      self.isComplete = true
    }
  },
  destroyed() {},
  methods: {
    agree() {
      this.isComplete = !this.isComplete
      this.checkAll()
    },
    checkAll() {
      if (this.isComplete) {
        this.complete()
      } else {
        this.notcomplete()
      }
    },
    complete() {
      this.$emit('complete')
    },
    notcomplete() {
      this.$emit('cancel')
    }
  }
}
</script>

<style lang="scss" scoped>
  #DocumentLimitTransactionDebtorInformation {
    padding-top: 30px;
    padding-bottom: 11px;
    .title {
      font-weight: 900;
      font-size: 16px;
      line-height: 1.5;
      color: #333333;
    }

    table {
      width: 100%;
      border-top: solid 1px #727d8c;
      border-collapse: collapse;
      margin-top: 11px;
      tr {
        border-bottom: solid 1px #d7e1ea;
        td {
          height: 48px;
        }
        td:first-child {
          width: calc(136% / 325 * 100);
          background-color: #f4faff;
          font-weight: 600;
          font-size: 15px;
          line-height: 2.13;
          text-align: center;
          color: #333333;
        }
        td:last-child {
          font-weight: 900;
          font-size: 16px;
          line-height: 2;
          text-align: center;
          color: #333333;
        }
      }
    }

    .agree {
      font-weight: 600;
      font-size: 16px;
      line-height: 48px;
      margin-top: 12px;
      width: 100%;

      button {
        width: 80px;
        height: 48px;
        border-radius: 4px;
        border: solid 1px #d7e1ea;
        background-color: #ffffff;
        font-size: 15px;
        line-height: 1.6;
        float: right;
      }
    }
  }
</style>
